export const columns = function () {
  return [
    {
      prop: 'id',
      label: 'ID',
      minWidth: 50
    },
    {
      prop: 'plate_num',
      label: '车辆',
      minWidth: 100
    },
    {
      prop: 'user_name',
      label: '姓名',
      minWidth: 50,
    },
    {
      prop: 'adjusters',
      label: '理赔员',
      minWidth: 50,
    },
    {
      prop: 'mobile',
      label: '手机号',
      minWidth: 50,
    },
    {
      prop: 'address',
      label: '事故地址',
      minWidth: 50,
    },
    {
      prop: 'reason',
      label: '原因',
      minWidth: 50,
    },
    {
      prop: "handle",
      label: "操作",
      minWidth: 50,
    },
  ]
}


export default {}